import http from '~/http/cryptomat';

export default ({
  state: {
    data: [],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_DATA(state, data) { state.data = data; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async toggleCurrencyTradeability(_store, id) {
      const res = await http.put(`/api/Currencies/${id}`);
      return !res?.data?.error;
    },

    async loadCurrencies({ getters, commit }) {
      const response = await http.get('/api/Currencies', {
        ...getters.requestData,
      });
      const { Currencies } = response.data;
      commit('SET_DATA', Currencies);
    },
  },

  namespaced: true,
});
